import { Factory } from 'fishery';

import { DeviceModel, DeviceStatus } from '@shure/shared/angular/data-access/system-api/models';

import { CloudGateway } from '../cloud-gateway';
import { CloudGatewayDiscoveredDevice } from '../cloud-gateway-discovered-device';
import { CloudGatewayManagedDeviceNode, CloudGatewayManagedPartialDevice } from '../cloud-gateway-managed-device';

export const cloudGatewayFactory = Factory.define<CloudGateway>(() => ({
	canManageDevices: true,
	maxManagedDeviceCount: 10,
	managedDevices: cloudGatewayManagedPartialDeviceFactory.buildList(3)
}));

export const cloudGatewayManagedPartialDeviceFactory = Factory.define<CloudGatewayManagedPartialDevice>(
	({ sequence }) => ({
		isDeviceNode: false,
		hardwareId: `hardware-id-${sequence}`,
		model: DeviceModel.P600,
		name: `Managed device ${sequence}`,
		status: DeviceStatus.Online,
		ipAddress: '123.456.7.8',
		macAddress: '12:34:56:78:90',
		serialNumber: 'ABCDEF123'
	})
);

export const cloudGatewayManagedDeviceNodeFactory = Factory.define<CloudGatewayManagedDeviceNode>(({ sequence }) => ({
	isDeviceNode: true,
	hardwareId: `hardware-id-${sequence}`,
	nodeId: `node-id-${sequence}`
}));

export const cloudGatewayDiscoveredDeviceFactory = Factory.define<CloudGatewayDiscoveredDevice>(({ sequence }) => ({
	hardwareId: `hardware-id-${sequence}`,
	model: DeviceModel.P600,
	name: `Managed device ${sequence}`,
	status: DeviceStatus.Online,
	ipAddress: '123.456.7.8',
	macAddress: '12:34:56:78:90',
	serialNumber: 'ABCDEF123',
	manageable: true,
	firmwareSupported: true
}));
